import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';
import { selectTicketPacks } from 'src/features/site-slice';
import { PackPurchaseCard } from './PackPurchaseCard';
import { Button } from 'src/redesign/components/Button';

type BuyCreditsPanelProps = {
  onClose: () => void;
};

export const BuyCreditsPanel = ({ onClose }: BuyCreditsPanelProps) => {
  const history = useHistory();
  const allPacks = useAppSelector(selectTicketPacks);
  const [purchasingPackId, setPurchasingPackId] = useState<string | null>(null);

  // Show first 4 packs
  const displayPacks = allPacks?.slice(0, 4) || [];

  const handleViewAll = () => {
    onClose();
    setTimeout(() => {
      history.push('/events/billing?view=packs');
    }, 100);
  };

  const handleGoToBilling = () => {
    onClose();
    setTimeout(() => {
      history.push('/events/billing');
    }, 100);
  };

  return (
    <div>
      <div className="flex align-items-center justify-content-between mb-3">
        <h3 className="text-xl font-bold m-0">Buy Ticket Packs</h3>
        <Button
          priority="secondary"
          size="small"
          onClick={handleGoToBilling}
          suffixIcon={<i className="pi pi-arrow-right" />}
        >
          Billing Portal
        </Button>
      </div>

      <div className="grid">
        {displayPacks.map((pack) => (
          <PackPurchaseCard
            key={pack.pack_id}
            pack={pack}
            isLoading={purchasingPackId === pack.pack_id}
            onPurchaseStart={() => setPurchasingPackId(pack.pack_id)}
            onPurchaseComplete={() => setPurchasingPackId(null)}
          />
        ))}
      </div>

      {allPacks && allPacks.length > 4 && (
        <div className="text-center mt-3">
          <Button priority="secondary" size="medium" onClick={handleViewAll}>
            View All Pack Options
          </Button>
        </div>
      )}

      {(!allPacks || allPacks.length === 0) && (
        <div className="text-center py-4 text-600">
          <i className="pi pi-inbox" style={{ fontSize: '2rem' }} />
          <div className="mt-2">No packs available</div>
        </div>
      )}
    </div>
  );
};
